import i18n from '../i18n'

const units = {
  celsius: ' °C',
  percent: ' %',
  m3: ' m³',
  wh: ' Wh',
  kwh: ' kWh',
  mwh: ' MWh',
  'gram per cubic meter': ' g/m³',
}

export function formatUnit(unit) {
  if (unit === 'units') {
    return ' ' + i18n.t('units.units')
  }
  return units[unit] || ' ' + unit
}
